import { FORMAT_DATE, FORMAT_MONTH } from '../constants/dateUtils';
import Dates from './dates';

class DateUtils {
  static getFirstDateByMonth(month) {
    const firstDateOfMonth = Dates.getStartDateOfMonth().toDate();
    return Dates.getWithAddMonths(month, firstDateOfMonth).toFormat(FORMAT_DATE);
  }

  static getLastDateByMonth(month) {
    const lastDateOfMonth = Dates.getEndDateOfMonth().toDate();
    return Dates.getWithAddMonths(month, lastDateOfMonth).toFormat(FORMAT_DATE);
  }

  static getMonthName(month) {
    return Dates.getWithAddMonths(month).toFormat(FORMAT_MONTH);
  }

  static getDate = () => {
    const today = new Date();
    const year = today.getFullYear().toString();
    const month = ('0' + (today.getMonth() + 1).toString()).slice(-2);
    const day = ('0' + today.getDate().toString()).slice(-2);
    return year + month + day;
  };

  static convertDate = (date) => {
    const dateArray = date.split('/');
    return dateArray[2] + dateArray[1] + dateArray[0];
  };

  static getAgeFromBirthDate = (timestampBirthDate) => {
    const birthDate = Dates.get(timestampBirthDate).toFormat('DD-MM-YYYY');
    const [birthdateDay, birthdateMonth, birthdateYear] = birthDate
      .split('-')
      .map((date, idx) => (idx === 1 ? parseInt(date, 10) - 1 : parseInt(date, 10)));
    const today = Dates.get();
    const currentMonth = parseInt(today.getMonth(), 10);
    const currentDay = parseInt(today.getDay(), 10);

    let age = parseInt(today.getYear(), 10) - birthdateYear;

    if (
      currentMonth < birthdateMonth ||
      (currentMonth < birthdateMonth && currentDay < birthdateDay)
    ) {
      age--;
    }

    return age;
  };
}

export default DateUtils;
